var headerTabsContent;

(function() {
    'use strict';

    if (!document.querySelector('#vue-header-tabs-content')) {
        return;
    }

    headerTabsContent = new Vue({
        el: '#vue-header-tabs-content',
        data: function() {
            return {
                currentIndex: 0,
                tabContents: null,
                initialized: false,
            };
        },
        computed: {},
        methods: {
            initTabContents: function() {
                this.tabContents = this.$el.querySelectorAll('.header__links');
                this.tabContents[this.currentIndex].classList.add('header__links--selected');
            },

            onHeaderTabClicked: function(tabIndex) {
                this.tabContents[this.currentIndex].classList.remove('header__links--selected');
                this.currentIndex = tabIndex;
                this.tabContents[this.currentIndex].classList.add('header__links--selected');
            },

            init: function() {
                if (this.initialized) {
                    return;
                }

                this.initialized = true;
                this.initTabContents();
                MpEventBus.$on('header-tab-clicked', this.onHeaderTabClicked);
            },
        },
        mounted: function() {
            this.init();
        },
        updated: function() {
            if (!this.initialized) {
                this.init();
            }
        },
    });
})();


